import uPlot from "uplot";
import { videoSeek } from "../plugins/videoSeek";

// Smooth (monotone-cubic bezier) throughput lines for a session, in Mbps over
// time. Each direction shows the bucket average as a solid line and the bucket
// peak (max) as a fainter dashed line. Monotone-cubic keeps the curve within
// the data range, so the y-axis floored at 0 never dips below zero.
//
// The x-axis is either wall-clock time (x_mode "real") or the recording's
// relative video time (x_mode "video"), in which case clicking a point seeks
// the player via the videoSeek plugin.
const RX_COLOR = "#6366f1"; // indigo-500
const TX_COLOR = "#10b981"; // emerald-500

function formatClock(totalSeconds) {
  const s = Math.max(0, Math.floor(totalSeconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const mm = String(m).padStart(h > 0 ? 2 : 1, "0");
  const ss = String(sec).padStart(2, "0");
  return h > 0 ? `${h}:${mm}:${ss}` : `${mm}:${ss}`;
}

export function network({ labels = {} } = {}) {
  const spline = uPlot.paths.spline();
  const videoAxis = labels.x_mode === "video";

  const avgSeries = (stroke, label) => ({ label, stroke, width: 2, paths: spline, spanGaps: true });
  const maxSeries = (stroke, label) => ({
    label,
    stroke,
    width: 1,
    paths: spline,
    spanGaps: true,
    dash: [6, 4],
  });

  return {
    plugins: [videoSeek({ ptsSeconds: labels.pts_seconds, target: labels.seek_target })],
    scales: {
      x: { time: !videoAxis },
      y: {
        range: (_u, _min, max) => [0, Math.max(max ?? 0, 1) * 1.1],
      },
    },
    axes: [videoAxis ? { values: (_u, splits) => splits.map(formatClock) } : {}, { label: "Mbps" }],
    series: [
      videoAxis
        ? { label: "Time", value: (_u, v) => (v == null ? "--" : formatClock(v)) }
        : { label: "Time" },
      avgSeries(RX_COLOR, "RX avg"),
      maxSeries(RX_COLOR, "RX max"),
      avgSeries(TX_COLOR, "TX avg"),
      maxSeries(TX_COLOR, "TX max"),
    ],
    legend: { show: true },
  };
}
